import { shiftStatus } from '@kioskgaming/ui';

export function scheduleShiftPath(cashierId?: string | null): string {
  if (!cashierId) return '/shifts/new';
  return `/shifts/new?cashierId=${encodeURIComponent(cashierId)}`;
}

export type CurrentShiftBadgeKind = 'none' | 'scheduled' | 'active' | 'attention';

export function currentShiftBadgeKind(status?: string | null): CurrentShiftBadgeKind {
  if (status === 'active') return 'active';
  if (status === 'scheduled') return 'scheduled';
  if (
    status === 'no_show' ||
    status === 'auto_locked' ||
    status === 'suspended' ||
    status === 'pending_reconciliation' ||
    status === 'pending_manager_review'
  ) {
    return 'attention';
  }
  return 'none';
}

/** Badge text for a Cashier's current shift; wording comes from the shared shift status map. */
export function currentShiftBadgeLabel(status?: string | null): string {
  if (currentShiftBadgeKind(status) === 'none') return 'No shift';
  return shiftStatus(status).label;
}
